import React, {useState} from 'react';
import ScrollListener from '../listener/scroll/ScrollListener';

interface NavigationState {
    isCollapsed: boolean;
}

const NavigationStateContext = React.createContext<NavigationState>({isCollapsed: false});

const NavigationStateProvider: React.FC = ({children}) => {
    const [state, setState] = useState<NavigationState>({isCollapsed: false});

    const onScroll = (distance: number) => {
        setState({isCollapsed: distance > 0});
    };

    return (
        <NavigationStateContext.Provider value={state}>
            <ScrollListener onScroll={onScroll} threshold={40} />
            {children}
        </NavigationStateContext.Provider>
    );
};

interface ContextProps {
    context: any;
}

interface ContextHoc extends React.ComponentClass<ContextProps> {
    getInitialProps?: () => void;
}

const withNavigationStateContext = (WrappedComponent: ContextHoc) => {
    const NavigationStateConsumer = ({context, ...props}: ContextProps) => (
        <NavigationStateContext.Consumer>
            {(navigationState) => <WrappedComponent context={{...context, navigationState}} {...props} />}
        </NavigationStateContext.Consumer>
    );

    NavigationStateConsumer.getInitialProps = WrappedComponent.getInitialProps;
    return NavigationStateConsumer;
};

export {NavigationStateContext, withNavigationStateContext};

export default NavigationStateProvider;
